import { TDate } from '@monorepo/types';
import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';

export type THolidayWithDescription = {
  date: TDate;
  description: string;
};

export const UPDATE_HOLIDAY_DESCRIPTION_FORM_MODEL = {
  createModel: (holidays: THolidayWithDescription[]): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: holidays.map((holiday) => ({
        input: {
          type: 'INPUT',
          value: holiday.description,
          placeholder: 'holiday_listing.holiday_description',
          subType: 'text',
        },
        metadata: {
          keyName: holiday.date,
          label: holiday.date,
        },
      })),
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
